import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { JoinOperator, RequiredPermissions } from 'src/app/models/permission.model';
import { AuthUser, NOT_ADMIN_PERMISSION } from '../../models/auth-user.model';
import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';
import { TranslateService } from '@ngx-translate/core';

interface Action {
  icon: string;
  label: string;
  exact: boolean;
  destination: string;
  enabled?: boolean;
  permissions?: RequiredPermissions;
  customCondition?: boolean;
  callback?: () => void;
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})


export class SidebarComponent {
  actions: Action[];
  currentUser: AuthUser;
  currentLang: string;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private translate: TranslateService
  ) {
    this.currentLang = this.translate.currentLang || this.translate.getDefaultLang() || 'en';
    this.translate.onLangChange.subscribe(event => {
      this.currentLang = event.lang;
    });

    this.actions = [
      {
        icon: 'fa-home',
        label: 'ROUTES.HOME',
        exact: true,
        destination: '',
      },
      {
        icon: 'fa-user-cog',
        label: 'ROUTES.USER',
        exact: false,
        destination: '/users',
        permissions: {
          permissions: ['users_management'],
          joinOperator: JoinOperator.AND
        }
      },
      {
        icon: 'fa-user-tag',
        label: 'ROUTES.ROLES',
        exact: false,
        destination: '/roles',
        permissions: {
          permissions: ['roles_management'],
          joinOperator: JoinOperator.AND
        }
      },
      {
        icon: 'fa-clinic-medical',
        label: 'ROUTES.MEDICAL_CENTER',
        exact: false,
        destination: '/medical-centers',
        permissions: {
          permissions: ['gestione_centri', 'viewer'],
          joinOperator: JoinOperator.OR
        }
      },
      {
        icon: 'fa-procedures',
        label: 'ROUTES.PATIENTS',
        exact: false,
        destination: '/patients',
        permissions: {
          permissions: ['gestione_pazienti', 'viewer', NOT_ADMIN_PERMISSION],
          joinOperator: JoinOperator.OR
        }
      },
      {
        icon: 'fa-sign-out-alt',
        label: 'Logout',
        exact: true,
        destination: 'logout',
        callback: () => {
          this.authenticationService.logout();
          this.userService.unsetUserInfo();
          this.router.navigate(['/login']);
        }
      }
    ];
  }
 setLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  } 
}
